import { Checkbox, Text } from '@thefarmersfront/kitchen';

import { FormField } from '~/components/common';

import type { TypeOwnerDetail } from '~/types/vender.types';

import styles from './VenderConfirmLogisticsInfoSection.module.scss';

type LogisticsType = 'NFA' | 'THIRD_PARTY_LOGISTICS';
type LogisticsKey = 'fulfillmentTypeFlag' | 'deliveryTypeFlag';

const LOGISTICS_KEYS: readonly LogisticsKey[] = ['fulfillmentTypeFlag', 'deliveryTypeFlag'] as const;

const LOGISTICS_LABEL: Record<LogisticsType, Record<LogisticsKey, string>> = {
  NFA: {
    fulfillmentTypeFlag: 'N배송',
    deliveryTypeFlag: 'N판매자배송',
  },
  THIRD_PARTY_LOGISTICS: {
    fulfillmentTypeFlag: '물류대행',
    deliveryTypeFlag: '배송대행',
  },
};
type TypeVenderConfirmLogisticsInfoSectionProps = {
  venderInfo: TypeOwnerDetail | null;
  type: LogisticsType;
};

const VenderConfirmLogisticsInfoSection = ({ venderInfo, type }: TypeVenderConfirmLogisticsInfoSectionProps) => {
  if (!venderInfo) return <></>;

  return (
    <div className={styles['section-container']}>
      <Text className={styles['section-title']} size="xxlarge" weight="bold" element="p">
        물류유형 정보
      </Text>
      <div className={styles['section-content']}>
        <FormField
          label="유형"
          contents={LOGISTICS_KEYS.map((key) => (
            <Checkbox
              key={key}
              size="medium"
              label={LOGISTICS_LABEL[type][key]}
              disabled
              checked={Boolean(venderInfo[key])}
            />
          ))}
          contentsClassName={styles['checkbox-group']}
          labelClassName={styles['checkbox-group-label']}
        />
      </div>
    </div>
  );
};

export default VenderConfirmLogisticsInfoSection;
